import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="w-full px-4 md:px-8 py-20 md:py-28">
      <div className="max-w-[640px] mx-auto text-center">
        <span className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-accent-100 text-accent-700 mb-6">
          <i className="ri-film-line text-3xl"></i>
        </span>
        <p className="font-heading text-6xl md:text-7xl font-black text-primary-200">404</p>
        <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mt-4">
          这个页面走丢了
        </h1>
        <p className="text-sm md:text-base text-foreground-600 leading-relaxed mt-3">
          你访问的页面可能已下线或链接有误。不如回到首页，或去剧集列表继续追《女友的妈妈》吧。
        </p>
        <div className="flex flex-wrap items-center justify-center gap-3 mt-8">
          <Link
            to="/"
            className="px-5 py-2.5 rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 text-sm whitespace-nowrap transition-colors"
          >
            返回首页
          </Link>
          <Link
            to="/episodes"
            className="px-5 py-2.5 rounded-md border border-background-300 text-foreground-800 hover:border-primary-400 hover:text-primary-600 text-sm whitespace-nowrap transition-colors"
          >
            查看剧集列表
          </Link>
        </div>
      </div>
    </div>
  );
}